<script setup>
import ListingColumnsList from '@/common/listing/ListingColumnsList.vue';

const props = defineProps({
    options: {
        type: Object,
        required: true
    }
});

defineEmits(['hide-modal']);

// --- Local Constants ---

// We grab the viewId once from the options.
// No need for a ref() here as it doesn't change during the modal's lifecycle.
const viewId = props.options.viewId;
</script>

<template>
    <div class="modal-dialog modal-narrow">
        <div class="modal-content">
            <div class="modal-header">
                <span class="text-muted small">Click a column to toggle its visibility.</span>
                <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    @click="$emit('hide-modal')"
                ></button>
            </div>

            <div class="modal-body p-0">
                <ListingColumnsList :view-id="viewId" />
            </div>
        </div>
    </div>
</template>

<style scoped>
/* Ensure the list feels integrated into the modal */
.modal-narrow {
    max-width: 400px;
}

.modal-body {
    max-height: 70vh;
    overflow-y: auto;
}
</style>